import {PeopleAlt, Phone} from '@mui/icons-material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {withStyles} from '@mui/styles';
import moment from 'moment';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {selectors as opportunitySelectors} from '../../../../Ducks/opportunity';
import {Grid} from "@mui/material";
import {PENDING} from "../../../Utils/constants";
import {findExternalEvent, ParticipationStatus} from "../../../Utils/commonUtils";


const useStyles = () => ({
    card: {
        backgroundColor: '#fff'
    },
    cardActions: {
        display: 'flex',
        flexDirection: 'row-reverse',
        marginRight: '-8px',
        marginBottom: '-8px'
    }
});

function Action(props) {
    const {classes, overview, plannedAction, events} = props;
    const [job, setJob] = React.useState({});
    const [event, setEvent] = React.useState();

    useEffect(() => {
        if (overview && overview.related_objects.opportunity_actions) {
            let jobId = overview.main.job_id;
            setJob(overview.related_objects.jobs[jobId] || {});
        }
    }, [overview]);

    useEffect(() => {
        const event = findExternalEvent(plannedAction, events, job);
        setEvent(event);
    }, [events, plannedAction, job]);

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                <Typography variant="h6" component="div" gutterBottom>
                    Planned Action {!plannedAction ? ': None' : ''}
                </Typography>
                {
                    plannedAction &&
                    (props.getAllEvents_loading ? "Loading" :
                            <>
                                <Grid container>
                                    <Grid item>
                                        <Typography variant="body2" color="site.main" gutterBottom>
                                            <b>{moment(plannedAction.opportunity_action_due_time).format("DD/MM/YYYY HH:mm")}</b>{' '}
                                        </Typography>
                                    </Grid>
                                    <Grid item sx={{pl: 1}}>
                                        {plannedAction?.event_synced === 1 &&
                                            <PeopleAlt color='primary' sx={{pb: '3px'}}/>}
                                    </Grid>
                                    <Grid item>
                                        {event && plannedAction?.event_synced === 1 ? <ParticipationStatus status={event.event_status_overall}/> :
                                            plannedAction?.event_synced === 1 ? <ParticipationStatus status={PENDING}/> : ''}
                                    </Grid>
                                </Grid>

                            </>
                    )
                }
                {
                    event && plannedAction && plannedAction.event_synced === 1 &&
                    <Typography variant="body2" color="site.main" gutterBottom component="div">
                        <div><b>Event Last Updated:</b></div>
                        {(new Date(event.updated).toLocaleString(undefined, {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: false
                                }))}
                    </Typography>
                }
                {
                    plannedAction && job && job.job_phone &&
                    <Typography variant="body2" color="site.main">
                        <a href={`callto:${job.job_phone}`} onClick={props.showActiveTab}
                           style={{textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center'}}>
                            <Phone sx={{color: 'icon.main', fontSize: "20px"}}/>
                            <span style={{marginLeft: '8px'}}>
                {job.job_phone}
              </span>
                        </a>
                    </Typography>
                }
                {
                    !plannedAction &&
                    <Typography variant="body2" color="site.main">
                        There is no planned action for this opportunity
                    </Typography>
                }

            </CardContent>
            <CardActions className={classes.cardActions}>
                <Button variant="contained" color="secondary" endIcon={<ArrowRightAltIcon/>} size="small"
                        onClick={() => props.handleTabChange('actions')}>Action</Button>
            </CardActions>
        </Card>
    );
}

const mapStateToProps = (state) => ({
    events: opportunitySelectors.events(state),
    getAllEvents_loading: opportunitySelectors.getAllEvents_loading(state),
    plannedAction: opportunitySelectors.plannedActionResponse(state),
});

export default connect(mapStateToProps)(withStyles(useStyles)(Action));